import { EditProfileController } from "./EditProfileController";
import { LoginController } from "./LoginController";
import { RegisterController } from "./RegisterController";
import { AlertModalController } from "./AlertModalController";
import { RecipeController } from "./RecipeController";
import { SettingsController } from "./SettingsController";
import { DashboardController } from "./DashboardController";
import { UserPreferencesController } from "./UserPreferencesController";
import { MealPlanController } from "./MealPlanController";
import { OnboardingController } from "./OnboardingController";
import { WaitlistController } from "./WaitlistController";

export const registerController = new RegisterController();
export const loginController = new LoginController();
export const editProfileController = new EditProfileController();
export const alertModalController = new AlertModalController();
export const recipeController = new RecipeController();
export const settingsController = new SettingsController();
export const dashboardController = new DashboardController();
export const userPreferencesController = new UserPreferencesController();
export const mealPlanController = new MealPlanController();
export const onboardingController = new OnboardingController();
export const waitlistController = new WaitlistController();
